export const watchersConstants = {
    // create candidate data
    GET_JOB_WATCHER_ACTION_REQUEST: "GET_JOB_WATCHER_ACTION_REQUEST",
    GET_JOB_WATCHER_ACTION_SUCCESS: "GET_JOB_WATCHER_ACTION_SUCCESS",
    GET_JOB_WATCHER_ACTION_FAILURE: "GET_JOB_WATCHER_ACTION_FAILURE",
}